<template>
  <tr>
    <template v-if="header">
      <td class="sticky-col nosort">
        <div class="account-name">Name</div>
      </td>
      <td class="sticky-col violations nosort">Violations</td>
      <td class="nosort text-center">Status</td>
      <td class="nosort">Stock Ticker</td>
      <td class="nosort">Stock Exchange</td>
      <td class="nosort">Ownership Type</td>
      <td class="nosort">SIC</td>
      <td class="nosort">No Domain</td>
      <td class="nosort">Domain</td>
    </template>

    <template v-else-if="account">
      <td class="sticky-col account-name">
        <div class="account-name">
          <router-link :to="`/account/${account.accountID}/edit`" data-test="account-name" :title="account.accountName">
            {{ filters.truncate(account.accountName, 30) }}
          </router-link>
        </div>
      </td>
      <td class="sticky-col violations">
        <div class="rule-container" v-for="accountRule in accountRules(account)" :key="accountRule.key">
          <Tooltip
            v-if="accountRule.violated"
            position="bottom"
            :text="`Rule: ${accountRule.desc} — Resolution: ${accountRule.resolution}`">
            <span
              class="mr-0.5 flex h-5 w-5 scale-[85%] items-center justify-center rounded-full bg-primary text-[10pt] font-bold text-white">
              <span class="h-fit w-fit font-mono">{{ accountRule.value }} </span>
            </span>
          </Tooltip>
        </div>
      </td>
      <td class="text-center">{{ account.accountStatus ?? '--' }}</td>
      <td>{{ account.stockTicker ?? '--' }}</td>
      <td>{{ account.stockExchange ?? '--' }}</td>
      <td>{{ account.ownershipType ?? '--' }}</td>
      <td>{{ account.sic ?? '--' }}</td>
      <td>{{ filters.bool(account.noDomain) }}</td>
      <td>{{ account.domainName ?? '--' }}</td>
    </template>
  </tr>
</template>

<script lang="ts">
import { DataQualityAccount, DataQualityRule } from '@/types/DataQuality';
import { DateTime } from 'luxon';
import { filters } from '@/utilities/Filters';
import Tooltip from '@/components/v2/Tooltip.vue';

export default {
  name: 'DataQualityAccountRow',
  components: { Tooltip },
  props: {
    header: Boolean,
    account: Object as () => DataQualityAccount,
    rules: Array as () => Readonly<DataQualityRule[]>
  },
  data: () => ({
    filters,
    DATETIME_SHORT: DateTime.DATETIME_SHORT
  }),
  methods: {
    accountRules(account: DataQualityAccount): (DataQualityRule & { violated: boolean })[] {
      if (!this.rules) return [];

      return this.rules.map((r, i) => ({ ...r, violated: Reflect.get(account, 'rule' + (i + 1)) }));
    }
  }
};
</script>

<style scoped>
.sticky-col {
  position: sticky;
  left: 0;
  z-index: 2;
}

thead .sticky-col {
  background: #f7f7f7;
}

table.apptable > tbody > tr > td.sticky-col {
  background: white;
}

.sticky-col:after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 2px;
  border-right: 1px solid var(--v-border-base);
}

.account-name {
  width: 250px;
  overflow: hidden;
}

.violations {
  left: 258px;
}

.rule-container {
  display: inline-block;
}

.rule {
  display: inline-block;
  color: #e7e7e7;
  cursor: pointer;
}
</style>
